import { Injectable } from '@angular/core';
import { environment } from '../../environments/environments'
import { HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UnitsService {

  constructor(private http: HttpClient) { }

  allUnits(name:string,type:string){
    return this.http.get(`${environment.baseUrl}/units/retrieve_unit_types/?unit_type=${type}&unit_name=${name}`)
  }
  allUnitsPagnation(curentPgae:any , limit:any){
    return this.http.get(`${environment.baseUrl}/units/retrieve_all_units?page=${curentPgae}&limit=${limit}`)
  }

  searchunit(unitname:string){
    return this.http.get(`${environment.baseUrl}/units/?unitname=${unitname}`)
  }

  unitDetails(unitname:string){
    return this.http.get(`${environment.baseUrl}/units/getUnitData/?unit_name=${unitname}`)
  }

  addunit(unitData:any){
    return this.http.post(`${environment.baseUrl}/units/`, unitData)
  }

  unitRelation(){
    return this.http.get(`${environment.baseUrl}/types/?name=unit relations`)
  }

  blockUnitForGate(data:any){
    return this.http.post(`${environment.baseUrl}/gates/blacklist_gate`,data)
  }

  whiteListGateUnit(data:any){
    return this.http.post(`${environment.baseUrl}/gates/whitelist_unit`,data)
  }

  balckListForClient(data:any){
    return this.http.post(`${environment.baseUrl}/gates/blacklist_clients`,data)
  }

  whiteListForClient(data:any){
    return this.http.post(`${environment.baseUrl}/gates/whitelist_clients`,data)
  }

  retiveUnitBlackList(id:any){
    return this.http.get(`${environment.baseUrl}/gates/blacklist_gate?unit_id=${id}`)
  }

  retiveClientBlackList(id:any){
    return this.http.get(`${environment.baseUrl}/gates/client_gates?client_id=${id}`)
  }

  removeBlackListGateClient(data:any){
    var myHeaders :any = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      body: data,
      redirect: 'follow'
    };
    return this.http.delete(`${environment.baseUrl}/gates/blacklist_clients`,requestOptions)
  }
  removeWhiteListGateClient(data:any){
    var myHeaders :any = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      body: data,
      redirect: 'follow'
    };
    return this.http.delete(`${environment.baseUrl}/gates/whitelist_clients`,requestOptions)
  }


  // unit types

  getTypes(){
    return this.http.get(`${environment.baseUrl}/types/?name=Unit Type`)
  }

  transferUnit(data:any){
    return this.http.put(`${environment.baseUrl}/client/transfer`,data)

  }

  // addclient 

  addClient(client:any){
    return this.http.post(`${environment.baseUrl}/client/`, client)
  }
  addClientImage(id: any, file: any){
  
      let auth_token = localStorage.getItem("acc_token")
      
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
  
      var myHeaders = new Headers();
      myHeaders.append('Authorization', `Bearer ${auth_token}`)
  
      var formdata = new FormData();
      file.forEach((element:any) => {
        console.log(element.type, element.path, element.path.name)
        formdata.append(element.type, element.path, element.path.name);
      });
   
      formdata.append("client_id", id);
  
      var requestOptions: any = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
  
      return fetch(`${environment.baseUrl}/images/`, requestOptions)
  }

  deletClientImage(id:any){
    return this.http.delete(`${environment.baseUrl}/images/?id=${id}`)
  }

  mergeClient(oldId:any,newId:any){
    return this.http.put(`${environment.baseUrl}/client/merge/?old_client_id=${oldId}&new_client_id=${newId}`,"")
  }

  deleltClient(id:any){
    return this.http.delete(`${environment.baseUrl}/client/?client_id=${id}`)
  }

  // quota

  addQuota(data:any){
    return this.http.post(`${environment.baseUrl}/qu/invitations`,data)
  }

  getQuota(unit_id:any , date : any){
    return this.http.get(`${environment.baseUrl}/qu/invitations?unit_id=${unit_id}&visit_date=${date}`)
  }

  // notes

  addNoteForUnit(data:any){
    return this.http.post(`${environment.baseUrl}/notes/unittnotes/`,data)
  }

  getNoteForUnit(unitId:any){
    return this.http.get(`${environment.baseUrl}/notes/unittnotes/?unit_id=${unitId}`)
  }

  addNoteForClient(data:any){
    return this.http.post(`${environment.baseUrl}/notes/clientnotes/`,data)
  }

  getNoteForClient(unitId:any){
    return this.http.get(`${environment.baseUrl}/notes/clientnotes/?client_id=${unitId}`)
  }

  deletNote(id:any){
    return this.http.delete(`${environment.baseUrl}/notes/delete/?note_id=${id}`)
  }

  // import client

  importClient(data:any){
    return this.http.post(`${environment.baseUrl}/client/shift`,data)
  }

  // qrTypes

  qrtypes(){
    return this.http.get(`${environment.baseUrl}/types/?name=Qr Access`)
  }

  // add invitation 

  clientInvtaion(data:any){
    return this.http.post(`${environment.baseUrl}/qr/invitation`,data)
  }
  clientSmsInvite(data:any){
    return this.http.post(`${environment.baseUrl}/qr/sms_request`,data)
  }

  retriveInvtaion(id:any){
    return this.http.get(`${environment.baseUrl}/qr/invitation?visit_date=2023-06-4&unit_id=${id}`)
  }

  // card types

  cardType(){
    return this.http.get(`${environment.baseUrl}/types/?name=access`)
  }

  addCard(data:any){
    return this.http.post(`${environment.baseUrl}/cards/`,data)
  }
  cardsList(id:any){
    return this.http.get(`${environment.baseUrl}/cards/?client_id=${id}`)
  }
  deleteCard(id:any){
    return this.http.delete(`${environment.baseUrl}/cards/?id=${id}`)
  }


  // qr types

  qrtype(){
    return this.http.get(`${environment.baseUrl}/types/?name=Qr`)
  }

  addRfid(data:any){
    var formdata = new FormData();
    formdata.append("front", data.front);
    formdata.append("back", data.back);
    formdata.append("card_id", data.card_id);
    formdata.append("client_id", data.client_id);
    formdata.append("license_plate", data.license_plate);
    formdata.append("serial_number", data.serial_number);
    formdata.append("type_id", data.type_id);
    if(data.unit_id){
      formdata.append("unit_id", data.unit_id);
    }
    let auth_token = localStorage.getItem("acc_token")
    var myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${auth_token}`)

    var requestOptions: any = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    return fetch(`${environment.baseUrl}/cards/rfid/`, requestOptions)
  }

  retriveRfid(id:any){
    return this.http.get(`${environment.baseUrl}/cards/rfids/?id=${id}`)
  }

  editRfid(data:any){
    var formdata = new FormData();
    
    if(data.front){
      formdata.append("front", data.front);
    }
    if(data.back){
      formdata.append("back", data.back);
    }
    formdata.append("card_id", data.card_id);
    formdata.append("client_id", data.client_id);
    formdata.append("license_plate", data.license_plate);
    formdata.append("serial_number", data.serial_number);
    formdata.append("type_id", data.type_id);
    formdata.append("unit_id", data.unit_id);
    formdata.append("id", data.id);
    let auth_token = localStorage.getItem("acc_token")
    var myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${auth_token}`)

    var requestOptions: any = {
      method: 'PUT',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    return fetch(`${environment.baseUrl}/cards/rfid/`, requestOptions)
  }

  deleteRfid(id:any){
    return this.http.delete(`${environment.baseUrl}/cards/rfid/?id=${id}`)
  }

  unit_invoice(id:any){
    return this.http.get(`${environment.baseUrl}/invoices/unit/?unit_id=${id}`)
  }
}
